import { IAugmentedJQuery, IDirective, IDirectiveFactory, IScope } from "angular";

export class SessionsGanttChart implements IDirective {
  public restrict = "A";
  private element: IAugmentedJQuery;

  public static factory(): IDirectiveFactory {
    const directive = () => new SessionsGanttChart();
    directive.$inject = [];
    return directive;
  }

  public link(scope: IScope, element: IAugmentedJQuery) {
    this.element = element;
    // If the main navigation is collapsed, first it renders as open, then it renders back as collapsed.
    // This behavior prevents the centerTodayLine() method to calculate properly the width of the page.
    window.setTimeoutOutsideAngular(() => this.centerTodayLine(), 200);
    this.element[0].addEventListener("mousemove", this.updateTimebarTooltipPosition);
    scope.$on("$destroy", () => {
      this.element[0].removeEventListener("mousemove", this.updateTimebarTooltipPosition);
    });
  }

  private centerTodayLine() {
    const scrollableArea = this.element[0];
    const todayMarker = this.element[0].querySelector<HTMLElement>(".today-marker");
    const sticky = this.element[0].querySelector<HTMLElement>(".sticky");
    if (scrollableArea && todayMarker && sticky) {
      scrollableArea.scrollTo({ left: todayMarker.offsetLeft - (scrollableArea.clientWidth - sticky.scrollWidth) / 2 });
    }
  }

  private updateTimebarTooltipPosition(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.classList.contains("time-bar")) {
      return;
    }
    const tooltip = target.parentElement.querySelector<HTMLElement>(".tooltip");
    if (tooltip) {
      requestAnimationFrame(() => {
        tooltip.style.left = `${target.offsetLeft + e.offsetX - tooltip.clientWidth / 2}px`;
      });
    }
  }
}
